import _pickBy from 'lodash/pickBy';

import { SidebarQueryKey } from '../enums';

export const getSearchQuery = (lessonPageId?: string | null, tab?: string | null) =>
  _pickBy({
    [SidebarQueryKey.LessonPageId]: lessonPageId as string,
    [SidebarQueryKey.Tab]: tab as string,
  });

export default getSearchQuery;
